import React from "react";
import NovakeyApp from "./NovakeyApp";
import { BrowserRouter } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <NovakeyApp />
    </BrowserRouter>
  );
}

export default App;
